import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface PlaceholderPageProps {
  titulo: string;
  descripcion: string;
  proximaFase: string;
}

/**
 * Página placeholder para rutas que aún no tienen implementación.
 * Mantiene el shell visual completo, indica claramente qué falta.
 */
export function PlaceholderPage({ titulo, descripcion, proximaFase }: PlaceholderPageProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-foreground">{titulo}</h1>
        <p className="mt-1 text-muted-foreground">{descripcion}</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Sección en construcción</CardTitle>
          <CardDescription>Disponible en {proximaFase}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Esta sección forma parte del roadmap pero no se ha implementado todavía. El backend
            tiene los endpoints listos; el frontend los conecta en la próxima fase.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
